import React from "react";
import { api } from "@/lib/api";

const Ctx = React.createContext({ cats: [], catMap: {}, settings: {}, refresh: () => {} });
export const useSite = () => React.useContext(Ctx);

export function SiteDataProvider({ children }) {
  const [cats, setCats] = React.useState([]);
  const [settings, setSettings] = React.useState({});

  const refresh = React.useCallback(() => {
    api.get("/categories").then((r) => setCats(r.data)).catch(() => {});
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  React.useEffect(() => { refresh(); }, [refresh]);

  const catMap = React.useMemo(
    () => Object.fromEntries(cats.map((c) => [c.key || c.id, c])),
    [cats]
  );

  return <Ctx.Provider value={{ cats, catMap, settings, refresh }}>{children}</Ctx.Provider>;
}
